import { post } from "services/api";

const ReportServices = {};

ReportServices.getReport = async (payload) => {
    return await post({ type: "trips", service: "trip/report", data: payload });  
}

export default ReportServices;